import { useEffect, useState, useMemo, useRef } from 'react';
import { Container, Options } from './styled';
import { Search } from '../../components';
import {
    HiChevronRight,
    HiChevronLeft,
    HiChevronDoubleLeft,
    HiChevronDoubleRight
} from 'react-icons/hi';


export function PickList(props) {
    const {
        ItemTemplate,
        identifier,
        options,
        setOptions,
        selecteds,
        setSelecteds,
        onFilterInFrom, onFilterInTo,
        searchInFrom, setSearchInFrom,
        searchInTo, setSearchInTo
    } = props;

    const [control, setControl] = useState('');
    const [select, setSelect] = useState([]);
    const [displayedOptions, setDisplayedOptions] = useState(50);
    const [displayedSelecteds, setDisplayedSelected] = useState(50);
    const listRefOptions = useRef(null);
    const listRefSelected = useRef(null);


    useEffect(() => {
        setSearchInFrom('');
        setSearchInTo('')
    }, []);
    const senderToDestiny = (item) => {
        setControl('destiny')
        setSelect(item)
    };
    const destinyToSender = (item) => {
        setControl('sender')
        setSelect(item)
    };
    const moveToDestiny = (all) => {
        if (!all) {
            const auxRemove = options.slice();
            auxRemove.splice(auxRemove.indexOf(select), 1)
            setOptions([...auxRemove])

            const auxAdd = selecteds
            auxAdd.push(select);
            setSelecteds([...auxAdd])
            return setControl('')
        }
        options.forEach(item => {
            const auxAdd = selecteds
            auxAdd.push(item);
            setSelecteds([...auxAdd])
        });
        setOptions([]);
        return setControl('')
    };
    const moveToSender = (all) => {
        if (!all) {
            const auxRemove = selecteds.slice();
            auxRemove.splice(auxRemove.indexOf(select), 1)
            setSelecteds([...auxRemove])

            const auxAdd = options
            auxAdd.push(select);
            setOptions([...auxAdd])
            return setControl('')
        }
        selecteds.forEach(item => {
            const auxAdd = options
            auxAdd.push(item);
            setOptions([...auxAdd])
        });
        setSelecteds([]);
        return setControl('')
    };

    const handleScrollOptions = () => {
        const element = listRefOptions.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedOptions(prevCount => prevCount + 50);
        }
    };
    useEffect(() => {
        const element = listRefOptions.current;
        element.addEventListener('scroll', handleScrollOptions);
        return () => element?.removeEventListener('scroll', handleScrollOptions);
    }, []);
    const visibleOptions = options
        .filter(onFilterInFrom)
        ?.slice(0, displayedOptions);
    const myOptions = useMemo(() =>
        visibleOptions?.map((item) => (
            <li
                key={item[`${identifier}`]}
                onClick={() => senderToDestiny(item)}
                className={`${item[identifier] === select[identifier]
                    && `select`}`
                }>
                <ItemTemplate item={item} />
            </li>
        )
        ), [visibleOptions]);


    const handleScrollSelected = () => {
        const element = listRefSelected.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedSelected(prevCount => prevCount + 50);
        }
    };
    useEffect(() => {
        const element = listRefSelected.current;
        element.addEventListener('scroll', handleScrollSelected);
        return () => element?.removeEventListener('scroll', handleScrollSelected);
    }, []);
    const visibleSelecteds = selecteds
        .filter(onFilterInTo)
        ?.slice(0, displayedSelecteds);
    const mySelecteds = useMemo(() =>
        visibleSelecteds?.map((item) => (
            <li
                key={item[`${identifier}`]}
                onClick={() => destinyToSender(item)}
                className={`${item[identifier] === select[identifier]
                    && `select`}`
                }>
                <ItemTemplate item={item} />
            </li>
        )
    ), [visibleSelecteds]);




    return (
        <Container>
            <div className='box'>
                <span>De</span>
                <Search
                    className='search--'
                    value={searchInFrom}
                    onChange={(e) => setSearchInFrom(e.target.value)}
                />
                <Options ref={listRefOptions}>
                    {myOptions}
                </Options>
            </div>
            <div className='controls'>
                <span
                    className={`${control !== 'destiny' && `none`}`}
                    onClick={() => moveToDestiny(false)}
                >
                    <HiChevronRight />
                </span>
                <span
                    className={`${control !== 'destiny' && `none`}`}
                    onClick={() => moveToDestiny(true)}
                >
                    <HiChevronDoubleRight />
                </span>
                <span
                    className={`${control !== 'sender' && `none`}`}
                    onClick={() => moveToSender(false)}
                >
                    <HiChevronLeft />
                </span>
                <span
                    className={`${control !== 'sender' && `none`}`}
                    onClick={() => moveToSender(true)}
                >
                    <HiChevronDoubleLeft />
                </span>
            </div>
            <div className='box'>
                <span>Para</span>
                <Search
                    className='search--'
                    value={searchInTo}
                    onChange={(e) => setSearchInTo(e.target.value)}
                />
                <Options ref={listRefSelected}>
                    {mySelecteds}
                </Options>
            </div>
        </Container>
    );
}